import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Theme,
  Modal,
  Button,
  ButtonTypes,
  ButtonSize,
  ButtonStyles,
  TextAlign,
  Input,
  MLPVersion,
  Card,
  FAIcon,
  DropDown,
  InputTypes,
  DatePicker,
  RadioButton,
} from '../../../../ui/components';
import { DropDownData } from '../../../../ui/components/Form/DropDown/types/propsType';
import { DynamicObjectInterface } from '../../../../sdk/type';
import styles from '../index.module.scss';
import { CoachData, MasterData } from '../coachConfig';
import { rewardTypeList } from '../../teams/edit/participant-details/editModal';

interface DetailsModalProps {
  onSave: DynamicObjectInterface;
  onCancel: DynamicObjectInterface;
  data: CoachData | null;
  masterData?: MasterData | null;
}

export const PointAllocationModal = ({ onSave, onCancel, data }: DetailsModalProps) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<CoachData | null>(JSON.parse(JSON.stringify(data)) as CoachData);

  /*const calculateTotal = () => ({
    cumulativePoint: Number(
      parseFloat(formData?.cumulativePoint.point ?? '0') + parseFloat(formData?.cumulativePoint.pointAdj ?? '0'),
    ).toFixed(1),
    newAboCount: Number(
      parseFloat(formData?.newAboCount.point ?? '0') + parseFloat(formData?.newAboCount.pointAdj ?? '0'),
    ).toFixed(1),
    newGroupAboCount: Number(
      parseFloat(formData?.newGroupAboCount.point ?? '0') + parseFloat(formData?.newGroupAboCount.pointAdj ?? '0'),
    ).toFixed(1),
  });*/

  //const [totalPoint, setTotalPoint] = useState(() => calculateTotal());

  const handleOnChange = (value: DynamicObjectInterface, key: keyof CoachData, ...paths: string[]) => {
    setFormData(prev => {
      if (!prev) return { ...prev! };
      const setDeep = (obj: DynamicObjectInterface, i = 0) => {
        if (paths.length !== i) {
          let path = i === 0 ? key : paths[i];
          let _obj = obj[path];
          if (_obj) obj = { ...obj, [path]: setDeep(_obj, i + 1) };
        } else {
          obj[paths[i - 1]] = value ?? 0;
        }
        return obj;
      };
      if (paths.length > 0) {
        return setDeep(formData) as CoachData;
      } else {
        return { ...prev, [key]: value };
      }
    });
    //setTotalPoint(() => calculateTotal());
  };

  const onPointInputBlur = (value: DynamicObjectInterface, key: keyof CoachData, ...paths: string[]) => {
    setFormData(prev => {
      if (!prev) return { ...prev! };
      const setDeep = (obj: DynamicObjectInterface, i = 0) => {
        if (paths.length !== i) {
          let path = i === 0 ? key : paths[i];
          let _obj = obj[path];
          if (_obj) obj = { ...obj, [path]: setDeep(_obj, i + 1) };
        } else {
          //obj[paths[i - 1]] = parseFloat(value ?? 0).toFixed(1);
          obj[paths[i - 1]] = parseInt(value ?? 0);
        }
        return obj;
      };
      if (paths.length > 0) {
        return setDeep(formData) as CoachData;
      } else {
        return { ...prev, [key]: value };
      }
    });
    //setTotalPoint(() => calculateTotal());
  };

  return (
    <Modal
      primaryButtonLabel={''}
      headline={''}
      closeIcon={false}
      containerWidth={'1000px'}
      primaryButton={
        <Button
          title={t('admin.participant.save')}
          type={ButtonTypes.BUTTON}
          onClick={() => {
            onSave(formData);
          }}
          size={ButtonSize.SMALL}
          buttonStyle={ButtonStyles.SOLID}
          data-testid="test-add-button-popup"
        />
      }
      secondaryButton={
        <Button
          title={t('admin.participant.cancel')}
          type={ButtonTypes.BUTTON}
          onClick={onCancel}
          size={ButtonSize.SMALL}
          buttonStyle={ButtonStyles.OUTLINE}
          theme={Theme.BLACK}
          data-testid="test-cancel-button-popup-delete-modal"
        />
      }
    >
      <div className={styles['modal-allocation']}>
        {/*<div>
          <div className={styles['slot-header']}>Point</div>
          <div className={styles['modal-allocation-form']}>
            <div>
              {/* <div className={styles['input-label']}>{t('admin.participant.point')}</div> 
              <div className={styles['point-input']}>
                <Input
                  name="point"
                  label={t('admin.participant.point')}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  value={parseFloat(formData?.cumulativePoint?.point || '0')?.toFixed(1)}
                  disabled
                />
                +
                <Input
                  name="adjustedPoint"
                  label={t('admin.participant.adjustment')}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  value={formData?.cumulativePoint?.pointAdj}
                  onBlur={e => onPointInputBlur(e.target.value || null, 'cumulativePoint', 'pointAdj')}
                  onChange={e => handleOnChange(e.target.value || null, 'cumulativePoint', 'pointAdj')}
                />
                =
                <Input
                  name="totalPoint"
                  label={t('admin.participant.total')}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  disabled
                  value={totalPoint.cumulativePoint}
                />
              </div>
            </div>
          </div>
        </div>*/}
        <div>
          {/*<div className={styles['slot-header']}>Personal Sponsor</div>*/}
          <div className={styles['modal-allocation-form']}>
            <div>
              {/* <div className={styles['input-label']}>{t('admin.participant.point')}</div> */}
              <div className={styles['point-input']}>
                <Input
                  name="point"
                  label={'Personal Sponsored'}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  value={formData?.newAboCount?.point}
                  onBlur={e => onPointInputBlur(e.target.value || null, 'newAboCount', 'point')}
                  onChange={e => handleOnChange(e.target.value || null, 'newAboCount', 'point')}
                />
                +
                <Input
                  name="adjustedPoint"
                  label={t('admin.participant.adjustment')}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  value={formData?.newAboCount?.pointAdj}
                  onBlur={e => onPointInputBlur(e.target.value || null, 'newAboCount', 'pointAdj')}
                  onChange={e => handleOnChange(e.target.value || null, 'newAboCount', 'pointAdj')}
                />
                =
                <Input
                  name="totalPoint"
                  label={t('admin.participant.total')}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  disabled
                  value={
                    parseFloat(formData?.newAboCount?.point ?? '0') + parseFloat(formData?.newAboCount?.pointAdj ?? '0')
                  }
                />
              </div>
              {/*<div className={styles['point-input']}>
                <Input
                  name="point"
                  label={'Group Sponsored'}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  value={formData?.newGroupAboCount?.point}
                  onBlur={e => onPointInputBlur(e.target.value || null, 'newGroupAboCount', 'point')}
                  onChange={e => handleOnChange(e.target.value || null, 'newGroupAboCount', 'point')}
                />
                +
                <Input
                  name="adjustedPoint"
                  label={t('admin.participant.adjustment')}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  value={formData?.newGroupAboCount?.pointAdj}
                  onBlur={e => onPointInputBlur(e.target.value || null, 'newGroupAboCount', 'pointAdj')}
                  onChange={e => handleOnChange(e.target.value || null, 'newGroupAboCount', 'pointAdj')}
                />
                =
                <Input
                  name="totalPoint"
                  label={t('admin.participant.total')}
                  mlpVersion={MLPVersion.ONE}
                  type={InputTypes.NUMBER}
                  disabled
                  value={(
                    parseFloat(formData?.newGroupAboCount?.point ?? '0') +
                    parseFloat(formData?.newGroupAboCount?.pointAdj ?? '0')
                  ).toFixed(1)}
                />
              </div>*/}
            </div>
          </div>
        </div>
        <div>
          <div className={styles['modal-allocation-remarks']}>
            <div style={{ width: '50%' }}>
              <Input
                name="remarks"
                label={t('admin.participant.remarks')}
                value={formData?.pointRemark}
                mlpVersion={MLPVersion.ONE}
                onChange={e => handleOnChange(e.target.value, 'pointRemark')}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const RewardGiftModal = ({ onSave, onCancel, data, masterData }: DetailsModalProps) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<CoachData | null>(JSON.parse(JSON.stringify(data)) as CoachData);
  const [showDelete, setShowDelete] = useState(-1);
  const [invalid, setInvalid] = useState(true);

  useEffect(() => {
    const validateInputs = (formData?.rewards || []).some(reward => !reward.rewardCode);
    setInvalid(validateInputs);
  }, [formData?.rewards]);

  const handleOnChange = (value: DynamicObjectInterface, name: string) => {
    if (name.startsWith('rewards.')) {
      setFormData(prev => {
        if (prev?.rewards && Array.isArray(prev.rewards)) {
          const updatedRewards = prev.rewards.map((reward, index) => {
            if (name.split('.')[1] === reward.rewardRecId.toString()) {
              const propertyName = name.split('.')[2];
              if (propertyName === 'rewardCode') {
                return {
                  ...reward,
                  [propertyName]: value,
                  rewardId: masterData?.reward?.find(i => i.rewardCode === value)?.recId,
                  rewardName: masterData?.reward?.find(i => i.rewardCode === value)?.rewardName,
                };
              } else if (propertyName === 'redeemDate') {
                return {
                  ...reward,
                  [propertyName]: value,
                  status: value ? 'USED' : 'ACTIVE',
                };
              } else {
                return {
                  ...reward,
                  [propertyName]: value,
                };
              }
            }
            return reward;
          });
          return { ...prev, rewards: updatedRewards };
        }
        return prev;
      });
    } else {
      setFormData(prev => ({ ...prev!, [name]: value }));
    }
  };

  const handleAddReward = () => {
    setFormData(prev => {
      if (prev?.rewards && Array.isArray(prev.rewards)) {
        const newReward = {
          rewardStatus: 'ACTIVE',
          isNew: true,
          rewardRecId: `NEW-${new Date()}`,
        };
        return { ...prev, rewards: [...prev.rewards, newReward] };
      }
      return prev;
    });
  };

  const handleDeleteButton = (rewardRecId: string) => {
    const index = formData?.rewards?.findIndex(i => i.rewardRecId === rewardRecId);
    if (index !== null && index !== undefined) setShowDelete(index);
  };

  const handleDeleteReward = (index: number) => {
    setFormData(prev => {
      if (prev?.rewards && Array.isArray(prev.rewards) && index >= 0 && index < prev.rewards.length) {
        const updatedRewards = [...prev.rewards];
        updatedRewards[index] = {
          ...updatedRewards[index],
          rewardStatus: 'REMOVED',
        };

        return { ...prev, rewards: updatedRewards };
      }
      return prev;
    });
    setShowDelete(-1);
  };

  const deletePrompt = (
    <>
      {showDelete !== -1 && (
        <Modal
          primaryButtonLabel={''}
          headline={`${t('admin.rewardMaster.deleteReward')}`}
          closeIcon={false}
          containerWidth={'460px'}
          primaryButton={
            <Button
              title={t('admin.rewardMaster.confirm')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                handleDeleteReward(showDelete);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
          secondaryButton={
            <Button
              title={t('admin.rewardMaster.cancel')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setShowDelete(-1);
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.OUTLINE}
              theme={Theme.BLACK}
              data-testid="test-cancel-button-popup-delete-modal"
            />
          }
        />
      )}
    </>
  );
  return (
    <Modal
      primaryButtonLabel={''}
      headline={t('admin.participant.editRewardDetail')}
      textAlign={TextAlign.LEFT}
      closeIcon={false}
      containerWidth={'1200px'}
      primaryButton={
        <Button
          title={t('admin.participant.save')}
          type={ButtonTypes.BUTTON}
          onClick={() => onSave(formData)}
          size={ButtonSize.SMALL}
          buttonStyle={ButtonStyles.SOLID}
          data-testid="test-add-button-popup"
          disabled={invalid}
        />
      }
      secondaryButton={
        <Button
          title={t('admin.participant.cancel')}
          type={ButtonTypes.BUTTON}
          onClick={onCancel}
          size={ButtonSize.SMALL}
          buttonStyle={ButtonStyles.OUTLINE}
          theme={Theme.BLACK}
          data-testid="test-cancel-button-popup-delete-modal"
        />
      }
    >
      <div
        className={`${styles['modal-reward']} ${
          formData?.rewards && formData?.rewards?.length > 0 ? styles['increased-height'] : ''
        }`}
      >
        {formData?.rewards
          ?.filter(r => r.rewardStatus !== 'REMOVED')
          ?.map((item, index) => (
            <Card key={item.rewardRecId}>
              <div className={styles['modal-reward-headline']}>
                <div>Reward {index + 1}</div>
                {!item?.rewardRecId?.toString()?.includes('NEW') && (
                  <FAIcon
                    iconName={'trash-can'}
                    onClick={e => {
                      handleDeleteButton(item?.rewardRecId);
                      e.stopPropagation();
                    }}
                    theme={Theme.RED}
                    title={'Delete'}
                    className={styles['modal-reward-delete']}
                  />
                )}
              </div>
              <div className={styles['modal-details-form']}>
                <DropDown
                  name={'rewardCode'}
                  dropdownLabel={`${t('admin.rewardMaster.rewardCode')}*`}
                  disabledFilter
                  mlpVersion={MLPVersion.ONE}
                  value={item?.rewardCode}
                  data={masterData?.reward?.filter(r =>
                    data?.configJson?.activities?.participant?.rewards?.rewardOptions?.['team'].includes(r.rewardCode),
                  )}
                  configData={{
                    label: 'rewardCode',
                    onSelect: (selectedOption: DropDownData) => {
                      handleOnChange(selectedOption.rewardCode, `rewards.${item.rewardRecId}.rewardCode`);
                    },
                  }}
                />
                <Input
                  name={'rewardName'}
                  value={item.rewardName}
                  disabled={true}
                  mlpVersion={MLPVersion.ONE}
                  label={t('admin.rewardMaster.rewardName')}
                />
                <DropDown
                  name={'rewardType'}
                  dropdownLabel={`Reward Type`}
                  disabledFilter
                  mlpVersion={MLPVersion.ONE}
                  value={rewardTypeList?.find(i => i.value === item?.rewardType)?.name}
                  data={rewardTypeList}
                  configData={{
                    label: 'name',
                    onSelect: (selectedOption: DropDownData) => {
                      handleOnChange(selectedOption.value, `rewards.${item.rewardRecId}.rewardType`);
                    },
                  }}
                />
              </div>
              <div className={styles['modal-details-form']}>
                <div className={styles['modal-details-form-span-2']}>
                  <div className={`${styles['input-container']}`}>
                    <div className={styles['label-text']}>{t('admin.campaignConfig.status')}</div>
                    <div className={styles['radio-button-container-edit']}>
                      <RadioButton
                        label={'Selected'}
                        checked={
                          (item.rewardStatus &&
                            item.rewardStatus.charAt(0).toUpperCase() + item.rewardStatus.slice(1)) === 'Selected'
                        }
                        onClick={() => {
                          handleOnChange('selected', `rewards.${item.rewardRecId}.rewardStatus`);
                        }}
                      />
                      <RadioButton
                        label={'Allocated'}
                        checked={
                          (item.rewardStatus &&
                            item.rewardStatus.charAt(0).toUpperCase() + item.rewardStatus.slice(1)) === 'Allocated'
                        }
                        onClick={() => {
                          handleOnChange('allocated', `rewards.${item.rewardRecId}.rewardStatus`);
                        }}
                      />
                      <RadioButton
                        label={'Distributed'}
                        checked={
                          (item.rewardStatus &&
                            item.rewardStatus.charAt(0).toUpperCase() + item.rewardStatus.slice(1)) === 'Distributed'
                        }
                        onClick={() => {
                          handleOnChange('distributed', `rewards.${item.rewardRecId}.rewardStatus`);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <DatePicker
                  data-testid={'test-date-picker-single'}
                  calendarHeading={'Updated Date'}
                  inputContainerHeight="36px"
                  containerWidth="450px"
                  value={item?.rewardModifiedDate ? new Date(item?.rewardModifiedDate) : undefined}
                  inputLabel={'Updated Date'}
                  onChange={date => {
                    if (date) {
                      date.setHours(0, 0, 0, 0);
                      handleOnChange(new Date(date), `rewards.${item.rewardRecId}.rewardModifiedDate`);
                    }
                  }}
                  onClear={() => handleOnChange('', `rewards.${item.rewardRecId}.rewardModifiedDate`)}
                />
              </div>
              <div className={styles['modal-details-form']}>
                <div className={styles['modal-details-form-span-2']}>
                  <Input
                    name={'remarks'}
                    value={item.rewardRemarks}
                    mlpVersion={MLPVersion.ONE}
                    label={t('admin.participant.remarks')}
                    onChange={e => handleOnChange(e.target.value, `rewards.${item.rewardRecId}.rewardRemarks`)}
                  />
                </div>
              </div>
              {deletePrompt}
            </Card>
          ))}
        <Button
          title={t('admin.participant.addReward')}
          type={ButtonTypes.BUTTON}
          onClick={handleAddReward}
          size={ButtonSize.SMALL}
          buttonStyle={ButtonStyles.OUTLINE}
          data-testid="test-add-button-popup"
        />
      </div>
    </Modal>
  );
};
